import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';

export const property: PropertyFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showPackage: false,
            showContractHolder: true,
            showContractNumber: true,
            fallbackAssistancePhonesKey: 'CZ',
            fallbackAssistanceEmailsKey: 'CZ',
        },
        propertySubjects: {
            showSimplifiedAddress: false,
        },
        showLinkedLoans: false,
    },
    history: {
        visible: true,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
